export const Colors = {
    lightgrey: "#EFEFEF",
    grey: "#808080",
    orange: "#F27322",
    lightOrange: "#E26D00",
    white: "#FFFFFF",
    lightGreen: "#616C58",
    darkGreen: "#1D331E"
};
